export default __webpack_public_path__ + "static/media/Bradley.14f90cd3.woff";